import Carousel from 'react-bootstrap/Carousel';
import classes from './PageCover.module.css';
import {useState, useEffect} from 'react';
import Fader from '../../Components/Fader/Fader';

const PageCover = ({images, interval, fadeText=""}) => {
	const [showFade, setShowFade] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShowFade(true);
        } ,3000);
    }, []);

	return (
		<>
			<div className={classes.coverContainer}>
                {
                    showFade && fadeText!==""? 
                    <Fader css={classes.fade}>
                            <p>{fadeText}</p>
                        </Fader> : null
                }
                
                <Carousel fade pause={false} 
                          className={classes.slideBoot} 
                          interval={interval} controls={false}>
                     {
                     	images.map((img, index) => 
                     		<Carousel.Item key={index}>
		                        <img src={img} className={classes.cover}/>  
		                    </Carousel.Item>)
                     }
                </Carousel>
                <div className={classes.shader}/>    
            </div>
		</>
	)
}

export default PageCover;